<template>
  <v-autocomplete
    v-model="val"
    :items="optionsToRender"
    multiple
    :readonly="readonly"
    :outlined="outlined"
    :dense="dense"
    :label="renderLabel"
    :class="renderClasses"
    :chips="filterMode"
    :deletable-chips="filterMode"
  />
</template>

<script>
import InputMixin from './mixins/InputMixin'

export default {
  name: '',

  mixins: [
    InputMixin
  ],

  props: {
    options: {
      type: Array,
      default: _ => []
    },

    filterMode: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    optionsToRender () {
      return this.options
    }
  },

  methods: {
    isValueTypeValid (value) {
      return Array.isArray(value)
    }
  }
}
</script>
